import { render, staticRenderFns } from "./BlockType110.vue?vue&type=template&id=4f40d390&scoped=true"
import script from "./BlockType110.vue?vue&type=script&lang=ts"
export * from "./BlockType110.vue?vue&type=script&lang=ts"
import style0 from "./BlockType110.vue?vue&type=style&index=0&id=4f40d390&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f40d390",
  null
  
)

export default component.exports